import React, { useContext } from 'react';
import { EnrollmentTracker } from './enrollment-tracker';
import { MainLayout, LayoutProps } from './layout';
import Banner from '../banner';
import RichText from '../rich-text';
import BackButton from '../back';
import DisclaimerFooter from '../footer/disclaimer-footer';
import { enrollmentContext } from '../../context/enrollment/enrollment-context';
import usePreviousPath from '../../../../hooks/usePreviousPath';
import { useLocation } from '@gatsbyjs/reach-router';

interface EnrollmentLayoutProps extends LayoutProps {
	title?: string;
	isBackButton?: boolean;
}

export const EnrollmentLayout: React.FC<EnrollmentLayoutProps> = ({
	children,
	label,
	mlrVersion,
	title,
	isBackButton = true,
}) => {
	const enrollmentCtxt = useContext(enrollmentContext);
	const { pathname } = useLocation();
	const previousPathName = usePreviousPath(pathname);
	//reset serviceDisclaimers only if it's already set and path changes
	if (
		enrollmentCtxt.serviceDisclaimers?.size !== 0 &&
		previousPathName &&
		pathname !== previousPathName
	) {
		enrollmentCtxt.serviceDisclaimers = new Set();
	}
	
	return (
		<MainLayout label={label} mlrVersion={mlrVersion}>
			<Banner>
				{title && (
					<h1 id="banner-title">
						<RichText html={title} />
					</h1>
				)}
				<EnrollmentTracker />
			</Banner>
			<div className="max-w-6xl mx-auto flex flex-col px-6 pt-3.5 pb-16 md:pt-12 md:pb-24 lg:px-2 gap-5 lg:gap-3">
				{isBackButton && <BackButton />}
				<div className="max-w-4xl mx-auto flex flex-col gap-8 lg:gap-12 items-center justify-center">
					{children}
					<DisclaimerFooter disclaimers={enrollmentCtxt.serviceDisclaimers} />
				</div>
			</div>
		</MainLayout>
	);
};
